import {crashlytics} from '../crashlytics';
import {
  CrashlyticsFatalError,
  CrashlyticsLogicError,
  RemoteCallError,
} from './exceptions';

export const ERROR_CONNECTION_FAILURE = 'Connection failure.';

export const processResponseFailed = async (
  response: Response,
  reference?: string,
): Promise<string> => {
  try {
    const fail: string = `Fail rest service: ${reference}`;
    let responseText: string;

    if (response.ok) {
      if (response?.bodyUsed) {
        const responseClone = response.clone();
        responseText = await responseClone.text();
      } else {
        responseText = await response.text();
      }
    } else {
      responseText = `Bad response from server - ${response.status}`;
    }

    if (responseText) {
      crashlytics().setAttributes({
        response: responseText,
      });
    }

    if (reference) {
      crashlytics().setAttributes({
        uri: reference,
      });
    }

    crashlytics().setAttributes({
      source: 'processResponseFailed',
    });

    crashlytics().recordError(new CrashlyticsLogicError(`${fail}`));
    crashlytics().sendUnsentReports();

    return 'The response from the server is failed.';
  } catch {
    return '';
  }
};

export const processFatalError = (
  exception: Error,
  reference?: string,
): string => {
  const fail: string = `Connection failure calling rest service: ${
    reference ?? ''
  }`;
  if (reference) {
    crashlytics().setAttributes({
      uri: reference,
    });
  }

  crashlytics().setAttributes({
    source: 'processResponseException',
  });

  crashlytics().recordError(new CrashlyticsFatalError(exception, fail));

  return ERROR_CONNECTION_FAILURE;
};

export {RemoteCallError};
